<div
  class="w-full flex flex-col-reverse justify-center max-lg:gap-4 max-lg:px-8"
  [ngClass]="{
    'bg-white': sideBySideImageTextData?.invert,
    'lg:flex-row lg:pl-6': !sideBySideImageTextData?.leftImage,
    'lg:flex-row-reverse lg:pr-6': sideBySideImageTextData?.leftImage,
    'pt-16 md:pt-24': sideBySideImageTextData?.topPadding,
    'pb-16 md:pb-24': sideBySideImageTextData?.bottomPadding,
    'items-start': sideBySideImageTextData.textTopAlign === 'top',
    'items-center': sideBySideImageTextData.textTopAlign === 'center',
  }"
>
  <div class="lg:px-14 xl:px-24 ssxl:px-32 w-full lg:w-1/2">
    <div
      [ngClass]="{ 'text-ss-brown': sideBySideImageTextData?.invert }"
      [innerHTML]="sideBySideImageTextData?.textContent"
      [ssDirectus]="{
        collection: 'sideBySideImageText',
        item: sideBySideImageTextData.id,
        fields: ['textContent'],
      }"
    ></div>
    @if (sideBySideImageTextData?.buttons?.length) {
      <div
        class="mt-6 flex flex-col grow justify-start gap-4 mx-auto max-w-4xl"
        [ssDirectus]="{
          collection: 'sideBySideImageText',
          item: sideBySideImageTextData.id,
          fields: ['buttons'],
        }"
        [ngClass]="{
          'md:flex-row flex-wrap': !sideBySideImageTextData.stackButtons,
        }"
      >
        @for (
          button of sideBySideImageTextData?.buttons;
          track buttons($index, button)
        ) {
          <ss-building-block-button-link
            [buttonLink]="button.item"
            class="flex-1 lg:flex-initial"
          ></ss-building-block-button-link>
        }
      </div>
    }
  </div>
  <div
    class="w-full lg:flex lg:flex-col lg:justify-center lg:w-1/2"
    [ssDirectus]="{
      collection: 'sideBySideImageText',
      item: sideBySideImageTextData.id,
      fields: ['image', 'video', 'videoProvider', 'customVideoThumbnail'],
    }"
  >
    @if (sideBySideImageTextData?.video) {
      <div
        class="w-full aspect-video overflow-hidden max-lg:rounded-xl relative"
        [ngClass]="
          sideBySideImageTextData?.leftImage
            ? 'lg:rounded-r-2xl'
            : 'lg:rounded-l-2xl'
        "
      >
        <div #video class="absolute inset-0 w-full h-full"></div>
        <!-- Display custom thumbnail for videos if available -->
        @if ((playClicked$ | async) === false) {
          @if (sideBySideImageTextData?.customVideoThumbnail) {
            <ss-www-image-with-loader
              class="w-full h-full"
              [fileDetail]="sideBySideImageTextData.customVideoThumbnail"
              desktopImageSize="half"
            ></ss-www-image-with-loader>
          }
          <ss-www-play-button-overlay
            (playClicked)="bigPlayButtonClicked()"
          ></ss-www-play-button-overlay>
        }
      </div>
    }
    @if (!sideBySideImageTextData?.video && sideBySideImageTextData?.image) {
      <ss-www-image-with-loader
        [@.disabled]="disableAnimation"
        class="w-full aspect-[35/23] max-lg:rounded-xl"
        [ngClass]="
          sideBySideImageTextData?.leftImage
            ? 'lg:rounded-r-2xl'
            : 'lg:rounded-l-2xl'
        "
        [fileDetail]="sideBySideImageTextData!.image"
        desktopImageSize="half"
      ></ss-www-image-with-loader>
    }
  </div>
</div>
